import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  Dashboard: {
    overflow: 'hidden',
    overflowY: 'auto',
    padding: '16px',
    height: 'max-content',
    maxHeight: 'calc(100dvh - 120px)',
    boxSizing: 'border-box',
    fontFamily: 'Be Vietnam Pro',
    borderRadius: 8,
    border: '1px solid var(--Gray-100, #F2F4F7)',
    background: 'var(--Base-White, #FFF)',
    boxShadow: '0 20px 24px -4px rgba(16, 24, 40, 0.08), 0 8px 8px -4px rgba(16, 24, 40, 0.03)',
  },
}));

const foodTruckGameStyles = makeStyles(() => ({
  Container: {
    position: 'relative',
    flexGrow: 1,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  ScheduleList: {
    flexGrow: 1,
    padding: '24px 16px',
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },
  ReferenceBox: {
    display: 'flex',
    gap: '16px',
    position: 'sticky',
    bottom: 0,
    height: 70,
    padding: '16px 40px',
    alignItems: 'center',
    boxShadow: '0 4px 8px 3px rgba(0, 0, 0, 0.15), 0 1px 3px 0 rgba(0, 0, 0, 0.30)',
  },
  MonthContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
  },
  ScheduleBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    borderRadius: 8,
    padding: 12,
    backgroundColor: '#F2F4F7',
    flex: '1 1 auto',
  },
  ScheduleItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    width: '100%',
    justifyContent: 'space-between',
  },
  AttendSwitch: {
    display: 'flex',
    flexDirection: 'column-reverse',
    gap: '2px',
    alignItems: 'center',
    '& .MuiTypography-root': {
      color: 'var(--Primary-500, #3D9F4A)',
      fontSize: 12,
      fontWeight: 400,
      lineHeight: '18px',
    },
  },
}));

const ButtonStyle = (color: string) => ({
  display: 'flex',
  padding: '9px 20px',
  justifyContent: 'center',
  alignItems: 'center',
  BoxSizing: 'border-box',
  gap: '8px',
  borderRadius: '8px',
  border: `1px solid ${color}`,
  background: color,
  ':hover': { background: color, opacity: 0.9 },
  opacity: 1,
  cursor: 'pointer',
});

export { ButtonStyle, foodTruckGameStyles, useStyles };

